// Fonte única de verdade dos planos no front (espelho de
// atende_flow_backend/src/config/planos.js — front e back são repositórios separados, sem
// pacote compartilhado, por isso a duplicação). Pra adicionar/remover um plano vendável: mexe
// aqui + no espelho do backend; PlanosPage.js renderiza os cards a partir de PLANOS_VENDAVEIS,
// então nenhum outro arquivo precisa mudar.

export const ORDEM = ['GRATIS', 'COMUM', 'PREMIUM', 'EMPRESARIAL'];

// A partir de qual plano (rank mínimo) cada feature fica liberada.
export const FEATURE_MINIMO = {
  financeiro: 'COMUM',
  diferenciais_cores: 'COMUM',
  descricao_servico: 'COMUM',
  visao_geral_completa: 'PREMIUM',
  marketing: 'PREMIUM',
  automacao_whatsapp: 'PREMIUM',
  gerenciar_equipe: 'EMPRESARIAL',
  google_multiplas_agendas: 'EMPRESARIAL',
};

export const LIMITES = {
  GRATIS: { agendamentos_dia: 10, whatsapp_instancias: 0 },
  COMUM: { agendamentos_dia: Infinity, whatsapp_instancias: 0 },
  PREMIUM: { agendamentos_dia: Infinity, whatsapp_instancias: 1 },
  EMPRESARIAL: { agendamentos_dia: Infinity, whatsapp_instancias: 5 },
};

export const PRECOS = {
  COMUM: { mensal: 14.90, anualMes: 10.90, anualTotal: 130.80, economia: 48 },
  PREMIUM: { mensal: 29.90, anualMes: 21.90, anualTotal: 262.80, economia: 96 },
  EMPRESARIAL: { mensal: 89.90, anualMes: 71.90, anualTotal: 862.80, economia: 216 },
};

// Teste grátis oferecido no primeiro acesso ao sistema (onboarding): quantos dias dura e qual
// plano fica liberado durante o período. Mudar aqui muda o trial em todo o sistema de uma vez.
export const TRIAL_PADRAO = { dias: 7, plano: 'PREMIUM' };

// Metadados de exibição pros cards de PlanosPage.js — só planos vendáveis (Grátis não passa
// por checkout, não entra aqui). Adicionar um plano novo = adicionar um item nesta lista.
export const PLANOS_VENDAVEIS = [
  {
    id: 'COMUM',
    nome: 'Plano Comum',
    badge: 'Essencial',
    descricao: 'Ideal para profissionais autônomos e clínicas individuais.',
    tema: 'slate',
    bullets: [
      'Agendamentos e clientes ilimitados',
      'Controle Financeiro (receitas e recebimentos)',
      'Diferenciais e cores personalizadas na página pública',
      '1 Google Agenda vinculada',
    ],
  },
  {
    id: 'PREMIUM',
    nome: 'Plano Premium',
    badge: 'Recomendado',
    descricao: 'Automatize seu marketing e a recepção via WhatsApp.',
    tema: 'purple',
    badgeSempreVisivel: true,
    bullets: [
      'Tudo do Plano Comum, e mais:',
      'Visão Geral completa (receita, aniversariantes, lembretes)',
      'Marketing completo: Cupons, Fidelidade e Aniversário automático',
      'Lembretes individuais e em massa',
      'Automação WhatsApp com bot conectado (1 número)',
    ],
  },
  {
    id: 'EMPRESARIAL',
    nome: 'Plano Empresarial',
    badge: 'Para Equipes',
    descricao: 'Sincronize a agenda de toda a sua equipe em um único robô.',
    tema: 'dark',
    bullets: [
      'Tudo do Plano Premium, e mais:',
      'Gerenciar Equipe (cadastre profissionais)',
      'Até 5 números de WhatsApp (recepção, vendas, cada atendente)',
      'Múltiplas Agendas Google (uma por profissional da equipe)',
    ],
  },
];

const rank = (plano) => ORDEM.indexOf(plano);

// Resolve o plano "efetivo": sem assinatura paga (trial válido ou ativa), o usuário é sempre
// GRATIS, não importa o que esteja salvo em `medico.plano`. Com assinatura paga mas plano
// desconhecido/nulo, assume COMUM (mesmo default já usado no resto do sistema).
export const resolverTier = (plano, isPago) => {
  if (!isPago) return 'GRATIS';
  return ORDEM.includes(plano) && plano !== 'GRATIS' ? plano : 'COMUM';
};

export const temAcesso = (plano, isPago, feature) => {
  const minimo = FEATURE_MINIMO[feature];
  if (!minimo) return true; // feature sem restrição de plano
  return rank(resolverTier(plano, isPago)) >= rank(minimo);
};

export const getLimite = (plano, isPago, chave) => LIMITES[resolverTier(plano, isPago)][chave];
